export var TableCellType;
(function (TableCellType) {
    TableCellType["TEXT"] = "text";
    TableCellType["LABEL"] = "label";
    TableCellType["STATUS"] = "status";
    TableCellType["CREDENTIAL_CARD"] = "credentialCard";
    TableCellType["ACTION_GROUP"] = "actionGroup";
})(TableCellType || (TableCellType = {}));
